const MAX_PERSON_NAME_LENGTH = 50;
const MAX_COMPANY_NAME_LENGTH = 100;
const VALID_PERSON_NAME_REGEX = /^[\p{L} \-'.]+$/u;
const VALID_COMPANY_NAME_REGEX = /^[\p{L}\p{N} \-'.,&()+!*"":°]+$/u;

// Matches URLs: protocol-based, www-based, and common TLD patterns
const LINK_REGEX = /(?:https?:\/\/|ftp:\/\/|file:\/\/|www\.|[a-z0-9][-a-z0-9]*\.(?:com|net|org|io|co|de|uk|fr|es|it|nl|be|at|ch|ru|cn|jp|kr|in|br|au|nz|edu|gov|mil)(?:[/\s]|$))/i;
// Matches email prefix before a domain match so we can exclude it
const EMAIL_PREFIX_REGEX = /[a-zA-Z0-9._%+-]+@$/;

function hasLink(input) {
  const matches = [...input.matchAll(new RegExp(LINK_REGEX, 'gi'))];
  return matches.some((match) => {
    if (match.index > 0) {
      const prefix = input.slice(0, match.index);
      if (EMAIL_PREFIX_REGEX.test(prefix)) {
        return false;
      }
    }
    return true;
  });
}

function hasExcessiveRepetition(s) {
  const lower = s.toLowerCase();
  const runes = [...lower];
  let count = 1;
  for (let i = 1; i < runes.length; i++) {
    if (runes[i] === runes[i - 1]) {
      count += 1;
      if (count >= 4) {
        return true;
      }
    } else {
      count = 1;
    }
  }
  return false;
}

export function validatePersonName(name, t) {
  const trimmed = name.trim();
  if (trimmed === '') {
    return t('nameValidation.personNameEmpty');
  }
  if ([...trimmed].length > MAX_PERSON_NAME_LENGTH) {
    return t('nameValidation.personNameTooLong', { max: MAX_PERSON_NAME_LENGTH });
  }
  if (!VALID_PERSON_NAME_REGEX.test(trimmed)) {
    return t('nameValidation.personNameInvalidChars');
  }
  if (hasExcessiveRepetition(trimmed)) {
    return t('nameValidation.excessiveRepetition');
  }
  if (hasLink(trimmed)) {
    return t('nameValidation.containsLink');
  }
  return '';
}

export function validateCompanyName(name, t) {
  const trimmed = name.trim();
  if (trimmed === '') {
    return t('nameValidation.companyNameEmpty');
  }
  if ([...trimmed].length > MAX_COMPANY_NAME_LENGTH) {
    return t('nameValidation.companyNameTooLong', { max: MAX_COMPANY_NAME_LENGTH });
  }
  if (!VALID_COMPANY_NAME_REGEX.test(trimmed)) {
    return t('nameValidation.companyNameInvalidChars');
  }
  if (hasExcessiveRepetition(trimmed)) {
    return t('nameValidation.excessiveRepetition');
  }
  if (hasLink(trimmed)) {
    return t('nameValidation.containsLink');
  }
  return '';
}
